import styled from '@app/styled';
import { color } from '@app/theme';

export const ProgressBarWrapper = styled.div`
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.1);
    border-radius: 24px;
    overflow: hidden;
    background-color: #eeeeee;
    height: 6px;
    width: 100%;
    display: flex;
`;

export const ProgressBarInner = styled.div`
    transition: width 0.2s;
    background-color: ${color('custom.interactive.primary.idle')};
    height: 100%;
`;
